<template>
  <v-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" max-width="600px" persistent>
    <div class="modal-content border-0 bg-white" style="background-color: #fff; border-radius: 12px; overflow: hidden;">
      <div class="modal-header bg-soft-info p-3" style="background-color: rgba(41, 156, 219, 0.1);">
        <h5 class="modal-title" id="suggestionModalLabel">
          <i class="bx bx-message-square-dots me-2 text-info"></i>
          Taklif va shikoyatlar
        </h5>
        <button type="button" class="btn-close" @click="$emit('update:modelValue', false)" aria-label="Close"></button>
      </div>
      
      <div class="modal-body p-0">
        <!-- Tabs -->
        <ul class="nav nav-tabs nav-tabs-custom nav-success nav-justified" role="tablist">
          <li class="nav-item">
            <a class="nav-link" :class="{ active: activeTab === 'new' }" @click.prevent="activeTab = 'new'" href="#">
              Yangi yaratish
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" :class="{ active: activeTab === 'list' }" @click.prevent="activeTab = 'list'" href="#">
              Arxiv
            </a>
          </li>
        </ul>

        <div class="tab-content p-4">
          <!-- Yangi Murojaat -->
          <div class="tab-pane" :class="{ active: activeTab === 'new' }">
            <form @submit.prevent="submitForm">
              <!-- Murojaat turi -->
              <div class="mb-3">
                <label for="appealType" class="form-label fw-medium">Xabar turi <span class="text-danger">*</span></label>
                <select class="form-select" id="appealType" v-model="form.type" required>
                  <option value="" disabled>Turini tanlang...</option>
                  <option v-for="type in types" :value="type.id" :key="type.id">{{ type.name }}</option>
                </select>
              </div>

              <!-- Matn -->
              <div class="mb-3">
                <label for="appealDescription" class="form-label fw-medium">Xabar matni <span class="text-danger">*</span></label>
                <textarea 
                  class="form-control" 
                  id="appealDescription" 
                  v-model="form.description" 
                  rows="4" 
                  placeholder="O'z fikr, taklif yoki murojaatingizni batafsil yozib qoldiring..."
                  required
                ></textarea>
              </div>

              <!-- Fayl -->
              <div class="mb-3">
                <label for="appealFile" class="form-label fw-medium">Fayl biriktirish (ixtiyoriy)</label>
                <input class="form-control" type="file" id="appealFile" @change="handleFileUpload">
                <small class="text-muted mt-1 d-block">Maksimal o'lcham: 5MB</small>
              </div>
            </form>
          </div>
          
          <!-- Mening murojaatlarim -->
          <div class="tab-pane" :class="{ active: activeTab === 'list' }">
            <div v-if="isLoadingAppeals" class="text-center py-4">
               <span class="spinner-border spinner-border-sm text-info"></span> Yuklanmoqda...
            </div>
            <div v-else-if="appealsList.length === 0" class="text-center py-4 text-muted">
               Sizda hozircha yuborilgan murojaatlar yo'q.
            </div>
            <div v-else class="appeals-list px-2 py-3">
               <div v-for="appeal in appealsList" :key="appeal.id" class="comment-thread mb-4 pb-2 border-bottom">
                 
                 <!-- Main Appeal (Comment style) -->
                 <div class="d-flex mb-2">
                    <img :src="getAvatarUrl(appeal.user)" @error="$event.target.src = getFallbackAvatar(appeal.user)" class="rounded-circle me-3 mt-1 object-fit-cover" width="40" height="40" alt="Avatar">
                    <div class="flex-grow-1">
                      <div class="d-flex justify-content-between align-items-center mb-1">
                        <div>
                          <span class="fw-bold fs-14 me-2">{{ appeal.user?.firstname || 'Foydalanuvchi' }} {{ appeal.user?.lastname || '' }}</span>
                          <span class="text-muted d-inline-flex align-items-center" style="font-size: 11px;">
                            <i class="bx bx-time-five me-1"></i>{{ formatDate(appeal.created_at) }}
                          </span>
                        </div>
                        <div style="font-size: 12px; color: #299cdb;" class="fw-medium">{{ getAppealTypeName(appeal.appeal_type_id) }}</div>
                      </div>
                      
                      <!-- Message text -->
                      <p class="mb-1 text-dark fs-14 lh-base" style="white-space: pre-wrap;">{{ appeal.message }}</p>
                      
                      <!-- File attachment -->
                      <div v-if="appeal.file_path" class="mt-2 mb-2">
                        <a :href="'https://api.task-board.uz/storage/' + appeal.file_path" target="_blank" class="text-decoration-none d-inline-flex align-items-center" style="font-size: 13px; font-weight: 500; color: #007bff;">
                          <i class="bx bx-paperclip me-1 fs-15"></i>Biriktirilgan fayl
                        </a>
                      </div>
                      
                      <!-- Actions -->
                      <div class="d-flex align-items-center mt-1">
                        <span class="cursor-pointer text-muted fw-medium reply-btn d-inline-flex align-items-center me-3" style="font-size: 13px;" @click="toggleReply(appeal.id)">
                          <i class="bx bx-reply me-1 fs-15"></i>Javob qaytarish
                        </span>
                        <span v-if="appeal.replies && appeal.replies.length > 0" class="cursor-pointer fw-medium d-inline-flex align-items-center show-replies-btn" style="font-size: 13px; color: #007bff;" @click="toggleReplies(appeal.id)">
                          <i class="bx me-1 fs-16" :class="expandedReplies.includes(appeal.id) ? 'bx-chevron-up' : 'bx-chevron-down'"></i>
                          {{ expandedReplies.includes(appeal.id) ? 'Javoblarni yashirish' : `${appeal.replies.length} ta javob` }}
                        </span>
                      </div>
                    </div>
                 </div>
                 
                 <!-- Replies Thread -->
                 <div class="replies-container ms-5 ps-2 mt-1" v-if="appeal.replies && appeal.replies.length > 0" v-show="expandedReplies.includes(appeal.id)">
                    <div v-for="(reply, rIndex) in appeal.replies" :key="rIndex" class="d-flex mt-3 mb-2">
                       <img :src="getAvatarUrl(reply.user)" @error="$event.target.src = getFallbackAvatar(reply.user)" class="rounded-circle me-2 mt-1 object-fit-cover" width="28" height="28" alt="Avatar">
                       <div class="flex-grow-1">
                          <div class="mb-1 d-flex align-items-baseline">
                            <span class="fw-semibold text-dark me-2" style="font-size: 12.5px;">{{ reply.user?.firstname || 'Admin' }} {{ reply.user?.lastname || '' }}</span>
                            <span class="text-muted d-inline-flex align-items-center" style="font-size: 11px;">
                              {{ formatDate(reply.created_at) }}
                            </span>
                          </div>
                          <p class="mb-0 fs-13 text-dark lh-base" style="white-space: pre-wrap;">{{ reply.message }}</p>
                       </div>
                    </div>
                 </div>

                 <!-- Reply Input form -->
                 <div v-if="replyingTo === appeal.id" class="reply-input-box ms-5 mt-3 d-flex align-items-start">
                    <img :src="getAvatarUrl(currentUser)" @error="$event.target.src = getFallbackAvatar(currentUser)" class="rounded-circle me-2 mt-1 object-fit-cover" width="32" height="32" alt="Avatar">
                    <div class="flex-grow-1">
                      <div class="d-flex align-items-end border-bottom border-primary border-2 pb-1">
                        <input type="text" class="form-control border-0 px-0 shadow-none bg-transparent" placeholder="Javob qoldiring..." v-model="replyMessage" @keyup.enter="sendReply(appeal.id)" style="font-size: 14px;">
                        <button class="btn btn-link text-primary p-0 ms-2 text-decoration-none fw-bold" @click="sendReply(appeal.id)" :disabled="isSendingReply || !replyMessage.trim()" style="font-size: 14px;">
                           <span v-if="isSendingReply" class="spinner-border spinner-border-sm"></span>
                           <span v-else>Yuborish</span>
                        </button>
                      </div>
                      <div class="text-end mt-1">
                        <span class="text-muted cursor-pointer" style="font-size: 12px;" @click="toggleReply(appeal.id)">Bekor qilish</span>
                      </div>
                    </div>
                 </div>
               </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="modal-footer p-3 bg-light">
        <button type="button" class="btn btn-light" @click="$emit('update:modelValue', false)">Yopish</button>
        <button v-if="activeTab === 'new'" type="button" class="btn btn-info" @click="submitForm" :disabled="isLoading">
          <span v-if="isLoading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
          <i v-else class="bx bx-send me-1"></i>
          Yuborish
        </button>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import api from '@/services/api';
import Swal from 'sweetalert2';

export default {
  name: 'SuggestionModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeTab: 'new',
      isLoading: false,
      isLoadingAppeals: false,
      isSendingReply: false,
      replyingTo: null,
      replyMessage: '',
      expandedReplies: [],
      appealsList: [],
      form: {
        type: '',
        description: '',
        file: null
      },
      types: []
    };
  },
  computed: {
    currentUser() {
      return this.$store?.state?.user || {};
    }
  },
  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.form.file = file;
      }
    },
    async submitForm() {
      if (!this.form.type || !this.form.description) {
        Swal.fire({
          icon: 'warning',
          title: 'Diqqat',
          text: 'Iltimos, murojaat turi va matnini to\'ldiring!',
          // confirmButtonColor: '#299cdb'
        });
        return;
      }

      this.isLoading = true;

      try {
        const formData = new FormData();
        formData.append('type', this.form.type);
        formData.append('message', this.form.description);
        if (this.form.file) {
          formData.append('file', this.form.file);
        }

        // Dasturchi eslatmasi: Foydalanuvchi qaysi endpoint ekanligini aytmadi, 
        // shu sababli pastdagi API urlni to'g'irlab qo'yish kerak bo'ladi.
        await api.post('/appeals', formData);

        Swal.fire({
          icon: 'success',
          title: 'Muvaffaqiyatli',
          text: 'Sizning murojaatingiz muvaffaqiyatli yuborildi!',
          confirmButtonColor: '#299cdb'
        });

        this.resetForm();
        this.$emit('update:modelValue', false);
        
      } catch (error) {
        console.error("Murojaat yuborishda xatolik:", error);
        Swal.fire({
          icon: 'error',
          title: 'Xatolik',
          text: 'Murojaatni yuborishda xatolik yuz berdi. Iltimos qayta urinib ko\'ring.',
          // confirmButtonColor: '#f06548'
        });
      } finally {
        this.isLoading = false;
      }
    },
    resetForm() {
      this.form = {
        type: '',
        description: '',
        file: null
      };
      const fileInput = document.getElementById('appealFile');
      if (fileInput) fileInput.value = '';
    },
    appealTypes() {
      api.get('/appeal-types').then(res => {
        this.types = res.data;
      }).catch(err => {
        console.log(err);
      })
    },
    fetchAppeals() {
      this.isLoadingAppeals = true;
      api.get('/appeals').then(res => {
        this.appealsList = res.data?.data || res.data || [];
      }).catch(err => {
        console.log("Murojaatlarni yuklashda xatolik:", err);
      }).finally(() => {
        this.isLoadingAppeals = false;
      });
    },
    getAppealTypeName(id) {
      const type = this.types.find(t => t.id === id);
      return type ? type.name : 'Noma\'lum';
    },
    getAvatarUrl(user) {
      if (!user || !user.avatar) return this.getFallbackAvatar(user);
      return `https://api.task-board.uz/storage/user/avatar/${user.avatar}`;
    },
    getFallbackAvatar(user) {
      const name = user && user.firstname ? `${user.firstname} ${user.lastname || ''}` : 'User';
      return `https://ui-avatars.com/api/?background=64748b&color=fff&name=${encodeURIComponent(name)}`;
    },
    toggleReply(id) {
      if (this.replyingTo === id) {
        this.replyingTo = null;
        this.replyMessage = '';
      } else {
        this.replyingTo = id;
        this.replyMessage = '';
      }
    },
    toggleReplies(id) {
      if (this.expandedReplies.includes(id)) {
        this.expandedReplies = this.expandedReplies.filter(rId => rId !== id);
      } else {
        this.expandedReplies.push(id);
      }
    },
    async sendReply(appealId) {
      if (!this.replyMessage.trim()) return;
      
      this.isSendingReply = true;
      try {
        const formData = new FormData();
        formData.append('message', this.replyMessage.trim());
        
        await api.post(`/appeals/${appealId}/reply`, formData);
        
        // Refresh the list after replying
        await this.fetchAppeals();
        
        this.replyingTo = null;
        this.replyMessage = '';
        
        // Optional success message (commented out to avoid annoying alerts on every reply)
        /*
        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'success',
          title: 'Javob yuborildi',
          showConfirmButton: false,
          timer: 1500
        });
        */
      } catch (error) {
        console.error("Javob yuborishda xatolik:", error);
        Swal.fire({
          icon: 'error',
          title: 'Xatolik',
          text: 'Javob yuborishda xatolik yuz berdi. Iltimos qayta urinib ko\'ring.',
        });
      } finally {
        this.isSendingReply = false;
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      return d.toLocaleDateString('uz-UZ') + ' ' + d.toLocaleTimeString('uz-UZ', { hour: '2-digit', minute: '2-digit' });
    }
  },
  watch: {
    modelValue(newVal) {
      if (!newVal) {
        this.resetForm();
        this.activeTab = 'new';
      } else {
        // Har safar oyna ochilganda yangilaymiz
        this.fetchAppeals();
      }
    },
    activeTab(newVal) {
      if (newVal === 'list' && this.appealsList.length === 0) {
        this.fetchAppeals();
      }
    }
  },
  mounted() {
    this.appealTypes();
  }
}
</script>

<style scoped>
.modal-content {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}
.bg-soft-info {
  background-color: rgba(41, 156, 219, 0.1) !important;
}
.btn-info {
  background-color: #299cdb;
  border-color: #299cdb;
  color: white;
}
.btn-info:hover {
  background-color: #2389c2;
  border-color: #2389c2;
}

.appeals-list {
  height: 480px;
  overflow-y: auto;
  overflow-x: hidden;
}
.appeals-list::-webkit-scrollbar {
  width: 5px;
}
.appeals-list::-webkit-scrollbar-thumb {
  background-color: #d1d5db;
  border-radius: 4px;
}
.appeals-list::-webkit-scrollbar-track {
  background: transparent;
}

.comment-thread:last-child {
  border-bottom: none !important;
}

.reply-btn {
  transition: color 0.2s;
}
.reply-btn:hover {
  color: #299cdb !important;
}
.show-replies-btn {
  transition: opacity 0.2s;
}
.show-replies-btn:hover {
  opacity: 0.8;
}
.cursor-pointer {
  cursor: pointer;
}

/* Youtube-like input style */
.reply-input-box input:focus {
  outline: none;
  box-shadow: none;
}
.reply-input-box .border-bottom {
  border-bottom-color: #299cdb !important;
}

.fs-14 { font-size: 14px; }
.fs-13 { font-size: 13px; }
.object-fit-cover { object-fit: cover; }
.lh-base { line-height: 1.5; }
</style>
